import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantResultPage } from './merchant-result';

@NgModule({
  declarations: [
    MerchantResultPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantResultPage),
    TranslateModule.forChild()
  ],
})
export class MerchantResultPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-result/merchant-result.module.ts